export default __webpack_public_path__ + "static/media/gallery-wip-emitter_07.ad86df37.jpg";